import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import { Modal, ModalBody, ModalFooter, Button, Input, Form } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import { resetPasswordRequest, clearRedux } from 'Redux/actions';

const ResetPassword = (props) => {
    const { isPMUser } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const { openModal, loading, passwordResult, entity } = useSelector(state => state.resetPasswordRedux);
    
    const closeModal = () => {
        dispatch(clearRedux("RESET_PASSWORD"));
    }

    const applyChanges = () => {
        let payload = {
            id: entity?.id,
            entityName: entity?.entityName,
            isPMUser
        }
        dispatch(resetPasswordRequest(payload))
    }

    useEffect(() => {
        
        if (passwordResult) {
            dispatch(clearRedux("RESET_PASSWORD", { passwordResult: null }))
            if (passwordResult?.reset) {
                NotificationManager.success(
                    messages['reset_password_success_message'],
                    messages['reset_password_title'],
                    3000,
                );
                closeModal();
            } else {
                NotificationManager.error(
                    messages['reset_password_error_message'],
                    messages['reset_password_title'],
                    3000,
                );
            }
            
        }
    }, [passwordResult])

    return (
        <Modal
            open={openModal}
            title={messages['reset_password_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div className="automatic-password-container">
                            <label style={{ marginRight: 5 }} className="input-normal-label">{messages['reset_password_message']} </label>
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                >
                    {messages['common_change']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ResetPassword;